import React from "react";
import { cn } from "../../../lib/cn";

/**
 * Checkbox — checkbox nativo estilizado.
 *
 * @example
 * <label className="flex items-center gap-2">
 *   <Checkbox checked={activo} onChange={e => setActivo(e.target.checked)} />
 *   <span>Activo</span>
 * </label>
 */
export const Checkbox = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <input
      ref={ref}
      type="checkbox"
      className={cn(
        "h-4 w-4 shrink-0 rounded-sm border border-input cursor-pointer",
        "accent-primary",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  );
});
Checkbox.displayName = "Checkbox";
